import { Component, signal, ViewChild, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/shared/services/toast.service';

@Component({
  selector: 'cert-bulk-ein-formatter-modal',
  templateUrl: './bulk-ein-formatter-modal.component.html',
  standalone: false,
})
export class BulkEinFormatterModalComponent implements AfterViewInit {
  @ViewChild('pastedInputTextarea') pastedInputTextarea: any;

  pastedInput = '';
  formattedOutput = signal('');
  private debounceTimer: any;
  private readonly debounceDelay = 500; // ms

  constructor(
    public activeModal: NgbActiveModal,
    private readonly toastService: ToastService,
  ) {}

  ngAfterViewInit() {
    this.pastedInputTextarea?.nativeElement?.focus();
  }

  formatEins() {
    clearTimeout(this.debounceTimer);

    if (!this.pastedInput.trim()) {
      this.formattedOutput.set('');
      return;
    }

    this.debounceTimer = setTimeout(() => {
      const eins = this.pastedInput
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line.length > 0)
        .map((ein) => ein.toUpperCase())
        .map((ein) => ein.padStart(7, '0'))
        .join(',');

      this.formattedOutput.set(eins);
      this.copyToClipboard();
    }, this.debounceDelay);
  }

  private copyToClipboard() {
    navigator.clipboard.writeText(this.formattedOutput()).then(() => {
      this.toastService.success('Value copied to clipboard');
    });
  }

  close() {
    this.activeModal.dismiss();
  }
}
